
//スライドの設定
$(function(){
  if ($('#js--slide').length) {
    $('#js--slide').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,
      adaptiveHeight: true
    });
    $('#js--slide').removeClass('loading');
  }
  if ($('.detail--slide').length) {
    $('.detail--slide').slick({
      dots: true,
      arrows: true,
      infinite: false,
    });
  }
});

// 見積り・請求ボックスタブ切り替え
$(function(){
  $('.js--tab-trigger').on('click', function() {
    $('#js--tab-trigger').children('.js--tab-trigger').toggleClass('is-tab-active');
    $('#js--tab-trigger').parents('aside').next('main').children('.tab-target').children('.js--tab-target').toggleClass('is-tab-active');
  });
});

// 見積り・請求ボックス未読切り替え
$(function(){
  $('.js--unread-filter-trigger').on('click', function() {
    const activeTab = $('#tab-estimates').attr('class').match(/is-tab-active/) ? 'estimates' : 'complete_estimates'
    window.location.href = $('a.unread-link')[0].href + `&active_tab=${activeTab}`
  });
});

// // メッセージの画面の高さ
// $(window).on('load resize', function(){
//   var windowHeight = $(window).outerHeight();
//   var headerHeight = $('.header-title').outerHeight();
//   var sendingboxHeight = $('.sending-box').outerHeight();
//   var textareaHeight = windowHeight - (headerHeight + sendingboxHeight );
//   if ( $(".sending-box").length ) {
//     var target = $(".sending-box").offset().top;
//   }

//   $('.message-area-box').css({'height' : textareaHeight + 'px'}).animate({scrollTop: target});
// });

// セレクトボックスカラー
$(function(){
  if($('.js--select select').find('option:selected').hasClass('js--select-first')) {
    $(this).css({'color': '#9a9a9a'});
  }
  $('.js--select  select').on('change', function(){
    if($(this).find('option:selected').hasClass('js--select-first')) {
      $(this).css({'color': '#9a9a9a'});
    } else {
      $(this).css({'color': '#555'});
    }
  });
});

// $(function(){
//   $('input,select,textarea', '#new_user').on('change', function() {
//     if ($('#new_user')[0].checkValidity()) {
//       $('[type=submit]', '#new_user').prop('disabled', false);
//     } else {
//       $('[type=submit]', '#new_user').prop('disabled', 'disabled');
//       $(this)[0].reportValidity();
//     }
//   })
//   $('#new_user').on('submit', function(e) {
//     $('[type=submit]', '#new_user').prop('disabled', 'disabled');
//     if ($(this)[0].checkValidity()) {
//       // Do submit
//     } else {
//       $('[type=submit]', '#new_user').prop('disabled', false);
//       e.preventDefault();
//     }
//   })
// });

$(function(){
  $(document).on('click','.js-modal-open', function(e){
    var target = $(this).data('target');
    var modal = document.getElementById(target);
    $(modal).fadeIn();
    e.preventDefault();
  });
  $(document).on('click','.js-modal-close',function(e){
    $('.js-modal').fadeOut();
    e.preventDefault();
  });
});

(function($){

  $(function(){
    if($('#js--equipment-exchange-item')){
      $('#js--equipment-exchange-item').on('click','li',function(){
        let target = $(this);
        if($('input', target).length > 0){
          let checked = $('input', target).prop('checked');
          $('input', target).prop('checked', !checked);
          target.toggleClass('checked');
        }
      });
    }
  });
  $(function(){
    $('#user_article_equipment_location').on('change',function(){
      let location = $(this).val();
      $('#equipment option').each(function(){
        let l = $(this).attr('data');
        $(this).hide();
        if(location === l ){
          $(this).show();
        }else if(l === 'none'){
          $(this).show();
          $(this).prop('selected',true);
        }
      });
    }).change();
    $('#equipment').on('change', function(){
      let equipment = $(this).val();
      $('#fixtures option').each(function(){
        let id = $(this).attr('data');
        $(this).hide();
        $(this).prop('selected',false);
        if(equipment === id ){
          $(this).show();
        }else if(id === 'none'){
          $(this).show();
        }
      });
    }).change();
  });
})(jQuery);

// 規約を最後までスクロールするまでログインボタンを押せない
$(function() {
  $("#agree").prop('disabled', true);
  var scrollend = false;
  $('#js--terms-box').on('scroll', function(event){
    if (
      scrollend == false
      && event.target.clientHeight + event.target.scrollTop >= (event.target.scrollHeight * 0.90)
    ) {
      $("#agree").prop('disabled', false);
      scrollend = true;
    }
  });
  $('#agree').on('change', function(event){
    $('#login-btn').prop('disabled', !$(this).prop('checked'))
  })
});

// ローディングアイコン
$(function(){
    $('.btn-message-link').on('click', function() {
        $('body').addClass('loading');
    });
});

// 対象物件の切り替え
$(function(){
  $('#user_article_switching_box_user_article_id').on('change', function() {
    $(this).parents('form').submit()
  })
})

// 見積モーダル
$(function(){
  $('[name="estimate[reply_method]"').on('change', function(){
    $('[name="estimate[reply_method_other]"]').toggle(this.value == 'その他').prop({disabled: (this.value != 'その他')})
  })
});

// GA Events
$(function(){
  if ( !window.gtag ) { return }
  $('form[action="/users/sign_in"]', document).on('submit',function(){
    gtag('event', 'login')
  })
})

$(function () {
  const handleReplySelect = function() {
    let replyMethod = $('#estimate-form_reply_method_default_form').val();
    if ($(".estimate-form_reply_method").length != 0) {
      if (replyMethod === 'メール') {
        $('.estimate-form_contact-email').show();
        $('.estimate-form_contact-tel').hide();
      } else if (replyMethod === 'お電話') {
        $('.estimate-form_contact-tel').show();
        $('.estimate-form_contact-email').hide();
      } else {
        $('.estimate-form_contact-tel').hide();
        $('.estimate-form_contact-email').hide();
      }
    }
  }
  // 初期表示時
  handleReplySelect();

  $(".estimate-form_reply_method").on('change', function() {
    handleReplySelect();
  });
});

$(function () {
  $(document).on('change','#estimate_contact_email', function(e){
    if (this.value === "") {
      this.setCustomValidity("メールアドレスを入力してください");
    } else if (!/@/.test(this.value)) {
      this.setCustomValidity("メールアドレスに「@」を挿入してください。「" + this.value + "」内に「@」がありません。");
    } else if (/[^\x00-\x7F]/.test(this.value)) {
      this.setCustomValidity("完全なメールアドレスではありません。半角で入力してください。");
    } else if (!/^[\w.+-]+@[\w-]+(\.[\w-]+)*$/.test(this.value)) {
      this.setCustomValidity("「" + this.value + "」は完全なメールアドレスではありません。「@」に続く文字列を入力してください。");
    } else {
      this.setCustomValidity("");
    }
  });
});

// チャットルーム遷移時のモーダル, 遷移&投稿時の最下部スクロール
$(function () {
  const latestMessage = document.querySelector(".bottom", "body.message-thread-show");
  if (latestMessage == null) { return; }
  latestMessage.scrollIntoView({ behavior: "auto" });
  var ref = document.referrer;console.log(ref)
  if ((performance.getEntriesByType("navigation").filter(pe=> pe.type == 'navigate').length == 0) || !ref.endsWith('/users/message_threads')) {
    return;
  }
  var close = $('.modal-close', "body.message-thread-show")
  var container = $('.modal-container', "body.message-thread-show");
  container.addClass('active');
  close.on('click',function(){
    container.removeClass('active');
  });
  $(document).on('click',function(e) {
    if(!$(e.target).closest('.modal-body').length) {
      container.removeClass('active');
    }
  });
});

// テキストエリアリサイズ
function flexTextarea(el) {
  const dummy = el.querySelector('.flex_textarea_dummy')
  el.querySelector('.flex_textarea_textarea').addEventListener('input', e => {
    dummy.textContent = e.target.value + '\u200b'
  })
}
document.querySelectorAll('.flex_textarea').forEach(flexTextarea)

// // メッセージフォーム 画像追加、投稿
$(function() {
  $(".message-form-photo-icon").on('click', function() {
    $("#file_attachment_field").trigger('click');
  });
  $("#file_attachment_field").on('change', function() {
    $(this).parents('form').submit();
  });
  $(".message-form-send-icon").on('click', function() {
    $(this).parents('form').submit();
  });
});

// キャンペーン応募ページのsubmitボタン
$(function() {
  const formFields = $('input,select,textarea', '#new_campaign_entry');
  const requiredFields = $('[required]', '#new_campaign_entry');
  const submitButton = $('[type=submit]', '#new_campaign_entry');

  checkFormFields();

  formFields.on('input change', checkFormFields);

  function checkFormFields() {
    let allFilled = true;

    requiredFields.each(function () {
      if (!$(this).val().trim()) {
        allFilled = false;
      }
    });

    if (allFilled) {
      submitButton.prop('disabled', false);
    } else {
      submitButton.prop('disabled', 'disabled');
    }
  }
})


// キャンペーン応募ページの郵便番号検索機能
import JpPrefecture from 'jp-prefecture';
$(function() {
  $('#campaign_entry_zip').on('input', function () {
    const zipCode = $(this).val().replace(/[^0-9]/g, ''); // 郵便番号の数値部分のみを取得
    // 郵便番号が7桁になったら検索
    if (zipCode.length === 7) {
      $.ajax({
        url: `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipCode}`,
        dataType: 'jsonp',
        success: function (data) {
          if (data.results) {
            const result = data.results[0];
            var prefectureName = result.address1;
            var prefectureCode = JpPrefecture.find('pref', prefectureName)?.id;

            if (prefectureCode) {
              $('#campaign_entry_prefecture').val(prefectureCode);
            } else {
              console.error('該当する都道府県が見つかりませんでした');
            }
            $('#campaign_entry_address').val(result.address2);       // 市区町村
            $('#campaign_entry_address_other').val(result.address3);       // 町域
          } else {
            alert('該当する住所が見つかりませんでした。直接入力をお願いします');
          }
        },
        error: function () {
          alert('住所の検索に失敗しました。直接入力をお願いします');
        },
      });
    }
  });
})

// AI査定類似事例の表示切り替え
$(function () {
  $("#similar-listing button").on("click", function () {
    const classname = $(".expandmore").attr("class");
    if (classname.includes("less")) {
      $(".expandmore").removeClass("less");
      $(".expandless").addClass("less");

      $("#similar-listing ul").show();
    } else {
      $(".expandmore").addClass("less");
      $(".expandless").removeClass("less");

      $("#similar-listing ul").hide();
    }
  });
});

// 自動ドア手動解錠
$(function() {
  $(".toggle-switch input").each(function() {
    const cardBody = $(this).closest('.entrance-card-header').next();
    if ($(this).prop('checked')) {
      $(".unlock-controls", cardBody).show()
    }
  });
  $(".toggle-switch input").on('change', function() {
    const card = $(this).closest('.entrance-card');
    const cardBody = $(this).closest('.entrance-card-header').next();
    if ($(this).prop('checked')) {
      $(".unlock-controls", cardBody).slideDown(250);
      $(card).addClass('active');
    }
    else {
      $(".unlock-controls", cardBody).slideUp(250);
      $(card).removeClass('active');
    }
  });
});

$(function() {
  $(".unlock").on("click touchmove", function (e) {
    if ($(this).prop('disabled')) {
      e.preventDefault();
      return;
    }
    var container = $(this).closest('.unlock-buttons');
    container.addClass('active');
    setTimeout(function(){
      container.addClass('complete');
    }, 500);
    setTimeout(function(){
      container.removeClass('active complete');
    }, 2500);
    e.preventDefault();
  });
});

// 解錠ページ初回モーダル
$(function() {
  $(".start_btn").on("click", function (e) {
    $(".first-step, .modal-footer").fadeOut();
    $(".second-step").fadeIn();
    e.preventDefault();
  });

  $('.tab-list-item').on('click', function(){
    let index = $('.tab-list-item').index(this);

    $('.tab-list-item').removeClass('is-btn-active');
    $(this).addClass('is-btn-active');
    $('.tab-contents').removeClass('is-contents-active');
    $('.tab-contents').eq(index).addClass('is-contents-active');
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const modalId = '#pre-member-modal-box';
  const openAction = '[data-action="open-pre-member-modal"]';
  const closeClass = '.js-modal-close';
  const showClass = 'is-show';

  const openButtons = document.querySelectorAll(openAction);
  const modal = document.querySelector(modalId);

  if (!modal) {
    return;
  }

  const closeButtons = modal.querySelectorAll(closeClass);

  openButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      modal.classList.add(showClass);
    });
  });

  closeButtons.forEach(close => {
    close.addEventListener('click', () => {
      modal.classList.remove(showClass);
    });
  });
});

/**
 * Handles opening the "Pre-Member" modal when a pre-member link is clicked
 * and closing the modal when its background or close button is clicked.
 *
 * Usage:
 *   - Add `class="pre-member-link"` to any link that should open the modal.
 *   - Add `id="pre-member-modal-box"` to the modal container.
 *   - Add `class="js-modal-close"` to modal background and close buttons.
 *   - Optionally, set `data-show="true"` on the modal to show it on page load.
 *
 * Events:
 *   - Dispatches a global "open-pre-member-modal" event when a pre-member link is clicked.
 */
document.addEventListener("DOMContentLoaded", () => {
  // Delegate click event to body for all .pre-member-link elements
  document.body.addEventListener("click", (e) => {
    const preMember = e.target.closest(".pre-member-link")
    if (!preMember) return
    // Open modal via custom event
    window.dispatchEvent(new Event("open-pre-member-modal"))
    // Close navigation menu if open
    const navInput = document.getElementById("nav-input")
    if (navInput) navInput.checked = false
  })

  // Initialize modal functionality
  const modal = document.getElementById('pre-member-modal-box');
  if (!modal) return;

  // Show modal on page load if `data-show="true"`
  if (modal.dataset.show === "true") {
    modal.classList.add('is-show');
  }

  // Attach click event listeners to modal close elements
  const closeElements = modal.querySelectorAll('.js-modal-close');
  closeElements.forEach(el => {
    el.addEventListener('click', () => modal.classList.remove('is-show'));
  });
})
